import { useQuery } from '@tanstack/react-query';

import { dashboardV2Client } from '../api/client';
import { dashboardV2QueryKeys } from '../api/queryKeys';
import { FilterOptions } from '../api/types';

// Option lists for the calendar "Show" control. Options rarely change, so
// this is cached generously.
const useDashboardFilters = (agencyId: number) =>
  useQuery<FilterOptions>({
    queryKey: dashboardV2QueryKeys.filters(agencyId),
    queryFn: () => dashboardV2Client.getFilters(agencyId),
    enabled: agencyId != null,
    staleTime: 5 * 60_000,
  });

export default useDashboardFilters;
